<section class="cads-welcome" aria-labelledby="cads-welcome-title">
  <h1 id="cads-welcome-title" class="cads-welcome__title">{{ config().title }}</h1>
  @if (config().subtitle) {
    <p class="cads-welcome__subtitle">{{ config().subtitle }}</p>
  }
</section>
